import { useMemo, useState } from "react";
import { Form, Input, Modal, Typography } from "antd";

import { setUnit, updateUnit } from "@/api/requests";
import CustomSelect from "@/components/inputs/CustomSelect";

const { Text } = Typography;

// Окно для редактирования списка рабочих групп заявки, содержит форму
const RequestUnitModal = ({
  data = {},
  units = [],
  request_form_uuid,
  visible,
  onSave,
  onCancel,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const allUnits = useMemo(() => {
    if (!data?.unit_uuid) return units;

    const exists = units.some((u) => u.uuid === data.unit_uuid);

    if (exists) return units;

    return [
      {
        uuid: data.unit_uuid,
        name: data.unit_name || "Без названия",
      },
      ...units,
    ];
  }, [units, data]);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      if (data?.uuid) {
        await updateUnit({
          ...data,
          ...values,
          request_form_uuid: request_form_uuid,
        });
      } else {
        await setUnit({
          ...values,
          request_form_uuid: request_form_uuid,
        });
      }

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title={
        !data?.uuid ? "Добавить целевую рабочую группу" : "Редактировать целевую рабочую группу"
      }
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Сохранить"
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          unit_uuid: data?.unit_uuid,
          unit_displayed_name: data?.unit_displayed_name,
          comment: data?.comment,
          uuid: data?.uuid,
        }}
        onFinish={handleSave}
      >
        <Form.Item
          name="unit_uuid"
          label="Рабочая группа"
          rules={[
            {
              required: true,
              message: "Пожалуйста, укажите рабочую группу",
            },
          ]}
        >
          <CustomSelect
            showSearch
            options={allUnits}
            fieldNames={{ label: "name", value: "uuid" }}
            optionFilterProp="name"
          />
        </Form.Item>

        <Form.Item name="unit_displayed_name" label="Название подразделения">
          <Input />
        </Form.Item>

        <Form.Item name="comment" label="Комментарий">
          <Input.TextArea />
        </Form.Item>

        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default RequestUnitModal;
